import React from "react";
import styles from "../Dashboard.module.css";

const Messages = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Messages</main>
    </div>
  );
};

export default Messages;
